import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const navigation = [
  { name: 'Technology', href: '/articles/Technology' },
  { name: 'Politics', href: '/articles/Politics' },
  { name: 'Culture', href: '/articles/Culture' },
];

const Navbar: React.FC = () => {
  const { user, profile, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [logoutError, setLogoutError] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const accountRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { pathname } = useLocation();
  const profileName = [profile?.first_name, profile?.last_name].filter(Boolean).join(' ')
    || user?.user_metadata?.full_name
    || user?.user_metadata?.name
    || profile?.username
    || user?.user_metadata?.username
    || user?.email?.split('@')[0]
    || 'My account';
  useEffect(() => { setMenuOpen(false); setLogoutError(false); }, [pathname, user?.id]);
  useEffect(() => {
    const closeOutside = (event: PointerEvent) => {
      if (!accountRef.current?.contains(event.target as Node)) setMenuOpen(false);
    };
    document.addEventListener('pointerdown', closeOutside);
    return () => document.removeEventListener('pointerdown', closeOutside);
  }, []);
  const logout = async () => {
    setLoggingOut(true); setLogoutError(false);
    try { await signOut(); setMenuOpen(false); }
    catch { setLogoutError(true); }
    finally { setLoggingOut(false); }
  };

  return <nav className="reference-nav" aria-label="Main navigation">
    <div className="reference-nav-row">
      <Link to="/" className="reference-brand" aria-label="Heretic home">Heretic</Link>
      <div className="reference-links">
        {navigation.map(item => <Link key={item.href} to={item.href} aria-current={pathname === item.href ? 'page' : undefined}>{item.name}</Link>)}
      </div>
      <div className="reference-auth">
        {user ? <div ref={accountRef} className="reference-account" onMouseEnter={() => setMenuOpen(true)} onMouseLeave={() => setMenuOpen(false)} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget as Node)) setMenuOpen(false); }} onKeyDown={event => { if (event.key === 'Escape') { setMenuOpen(false); triggerRef.current?.focus(); } }}>
          <button ref={triggerRef} type="button" className="reference-account-name" aria-expanded={menuOpen} aria-controls="account-dropdown" onClick={() => setMenuOpen(open => !open)} onKeyDown={event => { if (event.key === 'ArrowDown') { event.preventDefault(); setMenuOpen(true); } }}>
            {profileName}
          </button>
          {menuOpen && <div id="account-dropdown" className="reference-account-dropdown">
            <Link to="/profile">Profile</Link>
            <Link to="/dashboard">My articles</Link>
            <Link to="/submit">Post an article</Link>
            <button type="button" onClick={logout} disabled={loggingOut}>{loggingOut ? 'Logging out…' : 'Log out'}</button>
            {logoutError && <p role="alert">Could not log out. Please try again.</p>}
          </div>}
        </div> : <Link to="/login" aria-current={pathname === '/login' ? 'page' : undefined}>Login</Link>}
      </div>
    </div>
  </nav>;
};
export default Navbar;
